module.exports = __webpack_public_path__ + "img/logo-new-year.6f4c9cf2.png";